import { render, staticRenderFns } from "./InformacionFinanciera.vue?vue&type=template&id=4e31bd2e&scoped=true&"
import script from "./InformacionFinanciera.vue?vue&type=script&lang=js&"
export * from "./InformacionFinanciera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e31bd2e",
  null
  
)

export default component.exports